module.exports = __webpack_public_path__ + "static/img/6.64401c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/eng/6.png
// module id = YAiC
// module chunks = 0